import { render } from "./courtnotice-count.vue?vue&type=template&id=2264af50&scoped=true"
import script from "./courtnotice-count.vue?vue&type=script&lang=js"
export * from "./courtnotice-count.vue?vue&type=script&lang=js"

import "./courtnotice-count.vue?vue&type=style&index=0&id=2264af50&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2264af50"]])

export default __exports__